import { render, staticRenderFns } from "./arrowLeftIcon.vue?vue&type=template&id=ddf7a114"
import script from "./arrowLeftIcon.vue?vue&type=script&lang=js"
export * from "./arrowLeftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports